import React from 'react';
import map from 'lodash/map';
import { NonIdealState } from '@blueprintjs/core';
import {
  Table,
  ResultsHeaderRow,
  ResultsHoverTableRow,
  ResultsHeader,
  ResultsData,
  TableData,
} from 'components/styled-components';
import colors from 'utils/colors';
import { withRouter } from 'react-router';
import shortid from 'shortid';
import styled from 'styled-components';
import { shouldBold } from 'utils/functions';

const fields = [
  'Assessment ID',
  'Third Party Name',
  'Product / Service',
  'Contact Email',
  'Assessment Created Date',
];

const renderTable = (requests, history, query) => {
  return map(requests, request => {
    return (
      <ResultsHoverTableRow
        key={request.vendorRequestID}
        onClick={() => {
          history.push(
            `/renewals/${request.vendorRequestID}/${
              request.vendorInformation.vendorID
            }`
          );
        }}
      >
        <TableDataWithHeaders color={colors.primary}>
          {request.vendorRequestID}
        </TableDataWithHeaders>
        <TableDataWithHeaders>
          {request.vendorInformation
            ? shouldBold(request.vendorInformation.vendorName, query)
            : 'N/A'}
        </TableDataWithHeaders>
        <TableDataWithHeaders>
          {shouldBold(request.productServiceName, query)}
        </TableDataWithHeaders>
        <TableDataWithHeaders>
          {request.vendorContact ? request.vendorContact.map(vc => vc.email).join(', ') : 'N/A'}
        </TableDataWithHeaders>
        <TableDataWithHeaders>
          {request.requestSubmittedDate}
        </TableDataWithHeaders>
      </ResultsHoverTableRow>
    );
  });
};

const RenewalsTable = ({ requests, history, query }) => {
  return (
    <Table>
      <tbody>
        <ResultsHeaderRow>
          {fields.map(field => (
            <ResultsHeader key={shortid.generate()}>{field}</ResultsHeader>
          ))}
        </ResultsHeaderRow>

        {requests ? (
          renderTable(requests, history, query)
        ) : (
          <tr>
            <TableData colSpan={fields.length}>
              <NonIdealState
                icon="tick-circle"
                title="No Upcoming Renewals"
                description={
                  <>There are no upcoming renewals within the next 60 days.</>
                }
              />
            </TableData>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
	*/
    &:nth-of-type(1):before {
      content: 'Assessment ID';
      color: ${colors.gray};
    }
    &:nth-of-type(2):before {
      content: 'Third Party Name';
    }
    &:nth-of-type(3):before {
      content: 'Product / Service';
    }
    &:nth-of-type(4):before {
      content: 'Contact Email';
    }
    &:nth-of-type(5):before {
      content: 'Assessment Created Date';
    }
  }
`;

export default withRouter(RenewalsTable);
